import { createStore, del, get, set } from 'idb-keyval';

/**
 * Le « disque » du navigateur : IndexedDB, pour ce qui est trop gros pour
 * `localStorage` (le cache des requêtes, qui se compte en centaines de
 * kilo-octets).
 *
 * Même contrat que `disk-store` du mobile : lire, écrire, effacer un document
 * JSON par nom. Écrire ne fait jamais attendre l'écran, et un échec n'est jamais
 * une panne : l'application vit comme sans cache, elle recharge du réseau.
 */
let store: ReturnType<typeof createStore> | null = null;

function database() {
  if (store === null && typeof indexedDB !== 'undefined') {
    store = createStore('bul', 'documents');
  }
  return store;
}

export const diskStore = {
  async read(name: string): Promise<string | null> {
    const target = database();
    if (!target) {
      return null;
    }
    try {
      const value = await get<string>(name, target);
      return typeof value === 'string' ? value : null;
    } catch {
      return null;
    }
  },

  write(name: string, content: string): void {
    const target = database();
    if (!target) {
      return;
    }
    void set(name, content, target).catch(() => undefined);
  },

  remove(name: string): void {
    const target = database();
    if (!target) {
      return;
    }
    void del(name, target).catch(() => undefined);
  },
};
